import * as React from 'react'
import styled from 'styled-components'
import theme from 'theme'
import Filter from './Filter'
import ColorFilter from './ColorFilter'
import CustomizableFilter from './CustomizableFilter'

type Props = {
  openFilterDrawer: () => void
}

export default function FilterList(props: Props) {
  return (
    <Wrapper className="FilterList">
      <ColorFilter onMoreClick={props.openFilterDrawer} />

      <CustomizableFilter onInteract={props.openFilterDrawer} />

      <Filter
        filterKey="size"
        label="size_label"
        onInteract={props.openFilterDrawer}
      />
      <Filter
        filterKey="variant"
        label="variant_label"
        onInteract={props.openFilterDrawer}
      />
      <Filter
        filterKey="style"
        label="style_label"
        onInteract={props.openFilterDrawer}
      />
    </Wrapper>
  )
}

const Wrapper = styled.div`
  > div {
    > .label {
      ${theme._ty([16, 0.4, 22], theme.fontSpecial, '400')}
    }
  }
`
